export const baseURL = 'https://ktmedumarkfmbgk.com/';
//export const baseURL = 'http://69.62.82.4/';

// export const baseURL = 'http://65.1.51.239/';
//export const baseURL = 'https://3fe9-2409-40d2-12a6-c75a-4dd5-ba42-866f-f58b.ngrok-free.app/';
